const getReadableDateString = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US');
};

export default getReadableDateString;
